module.exports = __webpack_public_path__ + "static/HelveticaNowText-Regular.b031939748eb935aaebd8398d748f402.ttf";